require('./index.css')


var arr = ["TRANS_LOGO","TRANS_ONLINE","PRODUCT_INTRO","SYNC_SEND","TRANS_SERV"]

$(document).on('click', 'a[data-id]', function (e) {

  var vid = $(this).attr('data-id');
  _qblog.wsd.click('TRANSLATESYNCSPREAD.' + arr[vid-1]);
});


// WEBPACK FOOTER //
// ./modules/header/index.js